import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';

import defaultStyles from './CustomNavTitle.jss';

const CustomNavTitle = ({ primaryText, secondaryText }) => (
    <View style={defaultStyles.container}>
        <Text style={defaultStyles.primaryHeaderText}>{primaryText}</Text>
        <Text style={defaultStyles.secondaryHeaderText}>{secondaryText}</Text>
    </View>
);

CustomNavTitle.defaultProps = {
    secondaryText: null
};

CustomNavTitle.propTypes = {
    primaryText: PropTypes.string.isRequired,
    secondaryText: PropTypes.string
};

export default CustomNavTitle;
